module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('tplheader'), _vm._v(" "), _c('tplLeftPanel'), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "fixed-top-menu-outer",
    attrs: {
      "id": "fixed-top-menu-outer"
    }
  }, [_c('div', {
    staticClass: "fixed-top-menu"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('router-link', {
    staticClass: "btn btn-primary",
    attrs: {
      "to": {
        path: '/user/edit'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v("Új felhasználó")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "main-panel",
    attrs: {
      "id": "main-panel"
    }
  }, [_c('div', {
    staticClass: "content-panel"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "content-panel-top-btn-group"
  }, [_c('router-link', {
    staticClass: "btn btn-primary",
    attrs: {
      "to": {
        path: '/user/edit'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v("Új felhasználó")])], 1), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, [_vm._m(3), _vm._v(" "), _c('tbody', _vm._l((_vm.users), function(user) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(user.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.username))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.fullname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.email))]), _vm._v(" "), _c('td', [_c('ul', {
      staticClass: "icon-list"
    }, [_c('li', {
      staticClass: "dropdown"
    }, [_vm._m(4, true), _vm._v(" "), _c('ul', {
      staticClass: "dropdown-menu"
    }, [_c('li', {
      staticClass: "dropdown-header"
    }, [_vm._v("Opciók")]), _vm._v(" "), _c('li', [_c('router-link', {
      attrs: {
        "to": {
          path: '/user/edit/',
          query: {
            userID: user.id
          }
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil-square-o"
    }), _vm._v("Szerkeszt")])], 1), _vm._v(" "), _c('li', [_c('a', {
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          return _vm.del(user.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    }), _vm._v("Töröl")])])])])])])])
  }), 0)])])])])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "breadcrumb"
  }, [_c('li', [_vm._v("Kezdőőoldal")]), _vm._v(" "), _c('li', [_vm._v("Felhasználók")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-title"
  }, [_c('h1', [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("chevron_right")]), _vm._v("Felhasználók")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', [_vm._v("Felhasználók")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Felhasználó név")]), _vm._v(" "), _c('th', [_vm._v("Név")]), _vm._v(" "), _c('th', [_vm._v("Email")]), _vm._v(" "), _c('th')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_c('i', {
    staticClass: "fa fa-gear"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-206c0145"}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/users.vue
// module id = 51
// module chunks = 0